import * as React from 'react'
import { PlanningReason } from 'src/resources'

const configAcute = [
  'FUNERAL_TYPE',
  'CEREMONY',
  'PRODUCT',
  'ADDITIONAL_SERVICES',
  'LOCATION_FUNERAL',
  'COMMENT',
  'ADDITIONAL_INTERESTS'
]
const configProvision = [
  'FUNERAL_TYPE',
  'CEREMONY',
  'PRODUCT',
  'ADDITIONAL_SERVICES',
  'LOCATION_FUNERAL',
  'LAST_WILL',
  'MUSIC_SELECTION',
  'GUEST_LIST',
  'COMMENT'
]

interface ProviderProps {
  components: Map<string, JSX.Element>
  planningReason: PlanningReason
}

export const ComponentProvider = (props: ProviderProps) => {
  const { components, planningReason } = props
  const config = planningReason === 'PROVISION' ? configProvision : configAcute

  return (
    <>
      {config.map((k, i) =>
        React.cloneElement(components.get(k), { key: k, index: i + 1 })
      )}
    </>
  )
}

export default ComponentProvider



// WEBPACK FOOTER //
// ./src/components/containers/ComponentProvider.tsx